import { withStyles } from "@material-ui/core";
import { memo } from "react";
import SearchBar from "../../../../layout/layoutHeader/components/SearchBar";
import PlanDateHeader from "./PlanDateHeader";

const styles = (theme) => ({
  container: {
    padding: "2px 4px 4px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: 14,
    fontWeight: 600,
    marginRight: 8,
  },
});
const GridHeader = ({ glEventHub, headerId, title, classes }) => {
  return (
    <div id="gridHeader" className={classes.container}>
      <div className={classes.searchContainer}>
        <span className={classes.title}>{title}</span>
        <SearchBar eventHub={glEventHub} headerId={headerId} />
      </div>
      <PlanDateHeader />
    </div>
  );
};

export default withStyles(styles)(memo(GridHeader));
